import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getNotificationsApi,
  markAllReadApi,
  markReadByIdApi,
} from '@nxsys/services/api/notification';
import {
  GetNotificationParams,
  MarkAllReadParams,
  MarkReadByIdParams,
  NotificationListResponse,
} from '../types';

export const getNotification = createAsyncThunk<
  NotificationListResponse,
  GetNotificationParams
>(
  'notification/getNotification',
  async (params: GetNotificationParams, { rejectWithValue }) => {
    try {
      const { role, userId, subcontractorId, agencyId, ...queryParams } =
        params;
      const response = await getNotificationsApi(
        role,
        userId,
        subcontractorId,
        agencyId,
        queryParams,
      );
      return {
        data: response.data || [],
        totalUnread: response.totalUnread || 0,
        totalDocs: response.totalDocs || 0,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const markAllReadNotification = createAsyncThunk<
  void,
  MarkAllReadParams
>(
  'notification/markAllReadNotification',
  async (params: MarkAllReadParams, { rejectWithValue }) => {
    try {
      await markAllReadApi(
        params.role,
        params.userId,
        params.subcontractorId,
        params.agencyId,
      );
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const markReadNotification = createAsyncThunk<
  { id: string },
  MarkReadByIdParams
>(
  'notification/markReadNotification',
  async (params: MarkReadByIdParams, { rejectWithValue }) => {
    try {
      await markReadByIdApi(params.id);
      return { id: params.id };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
